import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import GridBackground from './GridBackground';
import CanvasExperience from './CanvasExperience';

const Card = ({ title, description, gradient, path }) => (
  <Link to={path}>
    <motion.div
      className="relative rounded-xl p-8 bg-purple-900/30 backdrop-blur-sm 
                 hover:bg-purple-900/40 transition-all duration-300"
      whileHover={{ scale: 1.02 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className={`absolute inset-0 bg-gradient-to-r ${gradient} 
                      opacity-0 hover:opacity-10 rounded-xl transition-opacity`} />
      <h3 className="text-xl font-bold mb-4 text-white">{title}</h3>
      <p className="text-purple-200">{description}</p>
    </motion.div>
  </Link>
);

const HomePage = () => {
  const cards = [
    {
      title: "Writing Competition",
      description: "We want to hear the stories bustling in your head and on the tips of your fingers.",
      gradient: "from-purple-500 to-blue-500",
      path: "/competition"
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-900 via-purple-800 to-purple-900 
                    text-white overflow-hidden relative">
      {/* Background layers */}
      <GridBackground />
      <CanvasExperience />
      
      {/* Main content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 py-24">
        <motion.h1 
          className="text-8xl font-bold mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <span className="bg-clip-text text-transparent bg-gradient-to-r 
                         from-pink-500 to-purple-500">
            Authenticity Fund
          </span>
        </motion.h1>

        <motion.div 
          className="text-2xl max-w-3xl mb-16 bg-purple-900/30 backdrop-blur-sm 
                     p-8 rounded-xl border border-purple-500/20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <p>
We believe that when labor is no longer scarce, the real value will be in what can’t be automated—genuine human connection and the things we choose to build and own. In a world where machines handle the rest, creativity, collaboration, and competition will be how we find purpose and shape what comes next.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Card {...card} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
